import React, { createContext, useState, useEffect } from "react";

//Firebase
import { auth, firestore } from "../config/config";

// Context
export const AuthContext = createContext();
export const AuthActionContext = createContext();

const AuthContextProvider = (props) => {
  const [user, setUser] = useState({});
  const [isAuth, setIsAuth] = useState(false);

  const date = new Date();
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const currentDate =
    date.getDate() + "-" + months[date.getMonth()] + "-" + date.getFullYear();

  const expireDate =
    date.getDate() +
    "-" +
    months[date.getMonth() + 1] +
    "-" +
    date.getFullYear();

  useEffect(() => {
    const userData = localStorage.getItem("UserData");
    const data = JSON.parse(userData);

    if (data !== null) {
      setUser(data);
      setIsAuth(true);
    }
  }, []);

  const signIn = (email, password, setWarn, setErr) => {
    auth
      .signInWithEmailAndPassword(email, password)
      .then((userCredential) => {
        var user = userCredential.user;

        !user.emailVerified
          ? unVerifiedEmail(user, setWarn)
          : firestore
              .collection("agencies")
              .doc(user.uid)
              .get()
              .then((doc) => {
                if (doc.exists) {
                  const data = doc.data();
                  const userData = {
                    createdAt: data.createdAt,
                    uid: data.uid,
                    name: data.name,
                    email: data.email,
                    avatar: data.avatar,
                    phoneNumber: data.phoneNumber,
                    country: data.country,
                    region: data.region,
                    address: data.address,
                    type: data.type,
                    buy: data.buy,
                    expire: data.expire,
                  };
                  localStorage.setItem("UserData", JSON.stringify(userData));
                  setUser(userData);
                  setIsAuth(true);
                } else {
                  // console.log("No such document!");
                  setErr("There is no such document!");
                }
              })
              .catch((error) => {
                // console.log("Error getting document:", error);
                setErr(error.message);
              });
      })
      .catch((error) => {
        var errorCode = error.code;
        errorCode === "auth/user-not-found"
          ? setErr("There is no user record. Please! Sign Up. Thanks")
          : setErr("Invalid User Credentials!");
      });
  };

  const unVerifiedEmail = (user, setWarn) => {
    user.sendEmailVerification();
    setWarn(
      "Please verify your email address! To verify check your email inbox for verification link. Thanks!",
    );
  };

  const signUp = (name, email, password, err) => {
    auth
      .createUserWithEmailAndPassword(email, password)
      .then((Credential) => {
        var user = Credential.user;
        console.log("User Data --> ", user);
        user
          .updateProfile({
            displayName: name,
          })
          .then(() => {
            user
              .sendEmailVerification()
              .then(() => {
                const userData = {
                  createdAt: currentDate,
                  uid: user.uid,
                  name: name,
                  email: user.email,
                  avatar: "",
                  phoneNumber: "",
                  country: "",
                  region: "",
                  address: "",
                  type: "trial",
                  buy: currentDate,
                  expire: expireDate,
                };
                setUser(userData);
                firestore
                  .collection("agencies")
                  .doc(user.uid)
                  .set(userData)
                  .then(() => {
                    setIsAuth(true);
                  })
                  .catch((error) => {
                    err(error.message, error.code);
                  });
              })
              .catch(function (error) {
                err(error.message, error.code);
              });
          });
      })
      .catch(function (error) {
        console.error("Error writing document: ", error);
        err(error.message, error.code);
      });
  };

  const userInfo = (phoneNumber, country, region, address, Err) => {
    firestore
      .collection("agencies")
      .doc(user["uid"])
      .update({
        phoneNumber: phoneNumber,
        country: country,
        region: region,
        address: address,
      })
      .then(() => {
        firestore
          .collection("agencies")
          .doc(user["uid"])
          .get()
          .then((doc) => {
            const data = doc.data();
            const userData = {
              createdAt: data.createdAt,
              uid: data.uid,
              name: data.name,
              email: data.email,
              avatar: data.avatar,
              phoneNumber: data.phoneNumber,
              country: data.country,
              region: data.region,
              address: data.address,
              type: data.type,
              buy: data.buy,
              expire: data.expire,
            };
            localStorage.setItem("UserData", JSON.stringify(userData));
            setUser(userData);
          });
      })
      .catch((err) => {
        Err(err.message);
      });
  };

  const recoverPass = (email, setErr, setSuccess) => {
    auth
      .sendPasswordResetEmail(email)
      .then(() => {
        setSuccess("Reset password link sent successfully!");
      })
      .catch((error) => {
        setErr(error.message);
      });
    setTimeout(() => {
      setSuccess("");
      setErr("");
    }, 10000);
  };

  const signOut = () => {
    auth.signOut().then(() => {
      window.location.reload();
      localStorage.removeItem("UserData");
      setUser("");
    });
  };

  return (
    <AuthContext.Provider value={{ user, isAuth }}>
      <AuthActionContext.Provider
        value={{ signIn, signUp, userInfo, recoverPass, signOut }}
      >
        {props.children}
      </AuthActionContext.Provider>
    </AuthContext.Provider>
  );
};

export default AuthContextProvider;
